import type { AppState } from '../../../../store/types';
import { getRouteSavedSearchId } from '../../../pages/search/utils';
import { selectSavedSearchWithFallback } from '../../../route_params/selectors';

// The metadata view shown in the filter panel and recorded when saving a search.
// Precedence: the current saved search's own view → the user's explicit pick this
// session → the configured "Filter metadata view" setting.
export const selectEffectiveMetadataViewId = (
  state: AppState,
): string | undefined => {
  const savedSearchViewId = selectSavedSearchWithFallback(
    state,
    getRouteSavedSearchId(state),
  )?.search_criteria_document?.criteria.metadata_view_id;
  const userPickedViewId =
    state.panelsState.searchFiltersMetadata.metadataViewId;
  const settingsViewId = state.settings.merged.filters_default_metadata_view_id;

  return savedSearchViewId ?? userPickedViewId ?? settingsViewId ?? undefined;
};
